import  { useContext } from "react";
import { Store } from "./Store";

export const useStore = () => {
  return useContext(Store);
};
